import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Heading from '../elements/Heading';
import globals from '../globals';
import TickList from "../elements/TickList";

class BasicList extends Component {
    
    componentDidMount() {
        this.controller = globals.genericAnimation(this.content);
    }

    componentWillUnmount() {
        globals.destroy(this.controller);
    }

    render() {
        return (
            <div className="basic-list reverse">
                <div className="top-wave-darkgreen" />
                <div className="row">
                    <div className="col-md-10 col-md-offset-1 col-xs-12" ref={el => this.content = el}>
						{(this.props.title !== '' ?
							<Heading title={this.props.title} subTitle={this.props.subTitle} />
							: '')}
                        <TickList list={this.props.list} reverse={this.props.reverse} />
                    </div>
                </div>
            </div>
        );
    }

}

BasicList.propTypes = {
	list: PropTypes.array,
	reverse: PropTypes.bool,
	title: PropTypes.string
};

BasicList.defaultProps = {
	reverse: false
};

export default BasicList;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/BasicList.js